import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(private datePipe: DatePipe) { }

  dateFormat(date: string): string
  {
    const dP: DatePipe = new DatePipe('en-AU');
    return dP.transform(date, 'yyyy-MM-dd') || '';
  }

  twoWeeksAgo(date: Date): string
  {
    const twoWeeksAgo = new Date(date.getTime() - 14 * 24 * 60 * 60 * 1000);
    return this.dateFormat(twoWeeksAgo.toISOString());
  }
  weeksAgo(weeks: number): string
  {
    const date = new Date();
    const weeksAgo = new Date(date.getTime() - weeks * 7 * 24 * 60 * 60 * 1000);
    return this.dateFormat(weeksAgo.toISOString());
  }
  getCurrentDateTime(){
    return this.datePipe.transform(new Date(), 'dd-MM-yyyy HH:mm');
  }

  getCurrentDate(): string {
    return this.datePipe.transform(new Date(), 'dd-MM-yyyy') || '';
  }

  getCurrentDateYearFirst(): string {
    return this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '';
  }

}
